<template>
<div style="background-color: #f6f6f6; padding-bottom: 40px;" key="1">
  <div class="header-image">
  </div>
  <div class="content-wrapper">
    <div class="content">
      <div class="title">Aviso de Privacidad</div>
      <div class="topic-content">
        <p>Gracias por visitar nuestro sitio Web, del cual es titular y responsable FLAGSHIP EQUITIES, S.A.P.I. DE C.V. (en adelante, “FLAGSHIP”) con domicilio en Campeche 233 Hipódromo, Ciudad de México, CP 06100, México. Este Aviso de Privacidad explica como FLAGSHIP recopila, registra, almacena y utiliza la información recabada sobre el usuario de este sitio Web y las decisiones que el usuario puede tomar sobre la forma en que dicha información se recopila y utiliza.</p>
        <p>Esta Política de Privacidad se aplica a todos los productos, servicios y sitios web ofrecidos por FLAGSHIP, sus subsidiarias, divisiones, marcas o compañías afiliadas ("Marcas y Servicios"). Respetamos su privacidad y estamos comprometidos a proteger la información personal que comparte con nosotros.</p>

        <h1>Información personal</h1>
        <p>Información personal significa cualquier información que pueda ser utilizada para identificar a un individuo, incluyendo, entre otros, nombre y apellido, fecha de nacimiento, dirección de correo electrónico, domicilio, RFC, CURP, ocupación, datos bancarios y cualquier otra información que sea necesaria para proporcionar un servicio o producto o llevar a cabo una transacción que haya solicitado.</p>
        <p>Cuando navega por nuestro sitio web, lo hace de forma anónima, a menos que se haya registrado previamente con nosotros. No recopilamos automáticamente información personal; registramos su dirección IP (la dirección de Internet de su computadora) para darnos una idea de qué parte de nuestro sitio web visita y cuánto tiempo pasa allí pero no vinculamos su dirección IP a ninguna información personal a menos que se haya registrado con nosotros.</p>

        <h1>Derechos</h1>

        <p>Todos los usuarios de nuestra página web tienen derecho a acceder, modificar o eliminar sus datos y objetar o restringir el procesamiento de los mismos. También puede dar instrucciones sobre lo que debería suceder con sus datos personales después de su muerte. A continuación, se señala más información sobre sus derechos:</p>

        <ul style="margin-left: 16px">
          <li>Derecho de acceso: puede solicitar una copia de sus datos personales procesados por FLAGSHIP;</li>
          <li>Derecho de modificación: si considera que sus datos personales son inexactos o están incompletos, tiene
          derecho a solicitar que se corrijan o modifiquen;</li>
          <li>Derecho a eliminar: puede solicitar la eliminación de sus datos bajo ciertas condiciones, por ejemplo, si
          considera que sus datos personales ya no son necesarios;</li>
          <li>Derecho a objetar: puede oponerse al procesamiento de sus datos personales en situaciones particulares;</li>
          <li>Derecho a restringir: puede solicitar que se restrinja el procesamiento de sus datos personales si:</li>
            <ul style="margin-left: 30px">
              <li>(i) niega la exactitud de sus datos personales;</li>
              <li>(ii) el procesamiento es ilegal y se opone a la eliminación de dichos datos;</li>
              <li>(iii) FLAGSHIP ya no necesita sus datos personales, pero dichos datos son aún necesarios para el
              establecimiento, ejercicio o defensa de reclamos legales; o</li>
              <li>(iv) se ha negado al procesamiento de estos datos;</li>
            </ul>
          <li>Derecho a dar instrucciones post-mortem: tiene derecho a dar instrucciones sobre cómo se conservarán,
            eliminarán y comunicarán sus datos personales después de su muerte.</li>
        </ul>

        <p style="margin-top: 16px;">Para ejercer cualquiera de estos derechos, envíenos un correo electrónico, adjuntando una copia de su identificación, a la siguiente dirección: info@flagship.mx Al igual que muchos otros sitios web comerciales, el sitio web de FLAGSHIP puede utilizar tecnologías estándar, como "cookies" y otras herramientas HTML, para recopilar información sobre cómo usa el sitio o para registrar que abrió un mensaje de marketing por correo electrónico.</p>

        <h1>Uso de cookies</h1>
        <p>Una cookie es un pequeño archivo de datos que ciertos sitios web escriben en el disco duro de su computadora cuando los visita. Un archivo de cookies puede contener información tal como una identificación de usuario que el sitio usa para rastrear las páginas que ha visitado, pero la única información personal que una cookie puede contener es la información que usted mismo proporciona al registrarse. Una cookie no puede leer datos de su disco duro ni leer archivos de cookies creados por otros sitios. FLAGSHIP usa cookies para monitorear la actividad en nuestros sitios web. No utilizamos cookies para recopilar información que lo identifique como persona, sino para comprender las diferentes computadoras, dispositivos, navegadores, etc. utilizados para acceder a nuestro sitio. Nos ayuda a analizar cómo se usa nuestro sitio y mejorar el servicio que le brindamos cuando visita nuestra página web. Si desea bloquear las cookies, consulte en su navegador en el menú de ayuda para obtener más información sobre cómo hacerlo. También es posible que usemos “Web beacons” que supervisan el uso que usted hace de nuestro sitio. Los “Web beacons” (o “Web bugs”) son pequeñas cadenas de código que permiten insertar imágenes, llamadas un píxel único (1 × 1) o GIF transparente, en una página Web a fin de transmitir datos y conocer el número de cookie de un visitante, la hora y la fecha de una vista de página, y una descripción de la página donde se ubica el “Web beacons”. Algunos web beacons pueden ser inutilizables si elige rechazar sus cookies asociadas. Al aceptar este Aviso de Privacidad, el usuario acepta expresamente nuestro uso de “cookies” y “Web beacons” tal como aquí se describe. El usuario puede configurar su navegador para que rechace las “cookies” de nuestro sitio Web, así como las de cualquier otro. Además, al configurar su navegador Web para que presente como sólo texto los archivos HTML que recibe por correo electrónico, es posible que pueda evitar el uso de algunos “Web beacons”. Si prefiere no recibir cookies mientras navega por nuestro sitio web o mediante correos electrónicos con formato HTML, puede configurar su navegador para que lo advierta antes de aceptar cookies y rechazarlas cuando su navegador lo avise de su presencia. También puede rechazar todas las cookies apagándolas en su navegador, aunque es posible que no pueda aprovechar al máximo el sitio web si lo hace.</p>

        <h1>Cambios</h1>
        <p>Si realizamos algún cambio en la política de privacidad de nuestro sitio web, lo publicaremos inmediatamente en esta página.</p>

        <h1>Contacto</h1>
        <p>En caso de tener alguna consulta o comentario sobre esta Política de Privacidad, estamos a su entera disposición en la dirección de correo electrónico info@flagship.mx que corresponde a la oficina responsable de la privacidad y protección de información, ubicada en Campeche 233 Hipódromo, Ciudad de México, CP 06100, México.</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import help from '@/assets/help.json';

export default {
  name: 'HelloWorld',
  data() {
    return {
      search: '',
      section: 0,
      help,
    };
  },
  props: {
    msg: String,
  },
  computed: {
    filteredSearch() {
      const searchVal = this.search;
      if (this.search !== '') {
        return this.help.filter(item => item.title.toLowerCase().includes(searchVal.toLowerCase()));
      } else if (this.section !== 0) {
        return this.help.filter(item => item.section === this.section);
      }
      return help;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header-image {
  height: 65vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("/header2.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.content-wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  margin-top: -40vh;
}
.content {
  width: 1200px;
  display: flex;
  background-color: white;
  padding: 90px 38px;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  border-radius: 6px;
}
.title {
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: bolder;
  font-size: 38px;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
  margin-bottom: 40px;
  span {
    color: #2c70c1;;
  }
}
.search-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}
.search {
  width: 400px;
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: bolder;
  font-size: 18px;
  padding: 14px 20px;
  box-sizing: border-box;
  border: 1px solid rgb(197, 197, 197);
  border-radius: 6px;
  margin: 34px 0;
  text-align: center;
}
.cards {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.card {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 30%;
  align-items: center;
  margin: 20px 0;
  padding: 50px 16px;
  border: 1px solid rgb(235, 235, 235);
  border-radius: 6px;
  cursor: pointer;
}
.card-title {
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: bolder;
  font-size: 24px;
  text-transform: uppercase;
  margin-bottom: 20px;
}
.card-img {
  margin-bottom: 40px;
}
.card-description {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  text-align: center;
}
.topic {
  margin: 30px 0;
}
.topic-title {
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: bolder;
  font-size: 18px;
  text-transform: uppercase;
  margin-bottom: 14px;
}
.topic-content {
  line-height: 22px;
  /deep/ h1 {
    color: #2c70c1;
    margin-top: 24px;
    margin-bottom: 6px;
  }
  /deep/ ol {
    margin: 8px 0;
  }
  p {
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 1200px) {
  .content {
    width: 100%;
  }
  .card {
    width: 45%;
  }
}
</style>
